import HospitalityAnalytics from "../../features/hospitality-analytics/HospitalityAnalytics";

export default function HospitalityAnalyticsPage() {
  return <HospitalityAnalytics />;
}

